export const ErrorPageRouting = {
  path: "/errorPage",
  name: "errorPage",
  meta: { title: "邀请失效" },
  component: () => import(/* webpackChunkName: "join" */ "@/views/join/h5/error-page/index.vue"),
  children: [],
};
